import React, { memo } from 'react';
import DayTabs from './DayTabs';
import DayTabContainer from './DayTabContainer';
import IntervalList from './IntervalList';
import { useFormWatch } from '../../../../../../helpers/formManager';
import { fieldPathBuilders } from '../../../../shared/configs/acceptanceForm';

const MemoizedTabContent = memo(TabContent);
const SettingIntervals = ({ deskIndex }) => {
  const isCommonSettings = useFormWatch({
    name: fieldPathBuilders.desk.isCommonSchedules(deskIndex),
    defaultValue: true,
  });

  if (isCommonSettings) {
    return <MemoizedTabContent deskIndex={deskIndex} />;
  }

  return <DayTabs deskIndex={deskIndex} tabContent={MemoizedTabContent} />;
};

export default SettingIntervals;

function TabContent(props) {
  return (
    <DayTabContainer {...props}>
      <IntervalList {...props} />
    </DayTabContainer>
  );
}
